// Curated list of watch brands accepted for consignment / direct sale at Mazad AD.
// Ordered alphabetically for the datalist dropdown. Users can also type a brand
// that is not in the list (e.g. rare independents) — the backend accepts free text.
export const WATCH_BRANDS = [
  "A. Lange & Söhne",
  "Alpina",
  "Angelus",
  "Anonimo",
  "Arnold & Son",
  "Audemars Piguet",
  "Ball Watch",
  "Baume & Mercier",
  "Bell & Ross",
  "Blancpain",
  "Bovet",
  "Breguet",
  "Breitling",
  "Bremont",
  "Bulgari",
  "Cartier",
  "Chanel",
  "Chopard",
  "Christopher Ward",
  "Chronoswiss",
  "Citizen",
  "Concord",
  "Corum",
  "Czapek",
  "De Bethune",
  "Dior",
  "Doxa",
  "Ebel",
  "F.P. Journe",
  "Farer",
  "Franck Muller",
  "Frederique Constant",
  "Girard-Perregaux",
  "Glashütte Original",
  "Grand Seiko",
  "Greubel Forsey",
  "H. Moser & Cie.",
  "Hamilton",
  "Hermès",
  "Hublot",
  "IWC",
  "Jaeger-LeCoultre",
  "Jaquet Droz",
  "Junghans",
  "Kari Voutilainen",
  "Laurent Ferrier",
  "Longines",
  "Louis Vuitton",
  "MB&F",
  "Maurice Lacroix",
  "Meistersinger",
  "Michele",
  "Mido",
  "Montblanc",
  "Movado",
  "NOMOS Glashütte",
  "Norqain",
  "Officine Panerai",
  "Omega",
  "Oris",
  "Panerai",
  "Parmigiani Fleurier",
  "Patek Philippe",
  "Perrelet",
  "Philippe Dufour",
  "Piaget",
  "Rado",
  "Raymond Weil",
  "Ressence",
  "Richard Mille",
  "Roger Dubuis",
  "Rolex",
  "Romain Gauthier",
  "Seiko",
  "Sinn",
  "TAG Heuer",
  "Tissot",
  "Tudor",
  "Tutima",
  "U-Boat",
  "Ulysse Nardin",
  "Universal Genève",
  "Urban Jürgensen",
  "Urwerk",
  "Vacheron Constantin",
  "Van Cleef & Arpels",
  "Vulcain",
  "Zenith",
  "Other",
];
